// extracted by mini-css-extract-plugin
export default {"wrapper":"FAQ_wrapper__lRxzQ","description":"FAQ_description__QFstE","list":"FAQ_list__uSnhk","link":"FAQ_link__r7uX0","icon":"FAQ_icon__dL9Cn","ani":"FAQ_ani__5BVlf"};